import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { appStore } from '../store'
import { toggleModal } from '../actions/modal'
import { actionBuildAutocomplete } from '../actions/withRedux'

class Modal extends Component {
  scrollingElement = null
  modal = null
  input = null

  componentDidMount () {
    this.modal = document.querySelector('.modal')
    this.input = this.modal.querySelector('.input')

    // Add active class to modal
    this.modal.classList.add('active')
    this.input.focus()
    this.input.click() // Fix autocomplete not open
  }

  hide = () => {
    // Add hide class to modal
    this.modal.classList.remove('active')

    setTimeout(() => {
      appStore.dispatch(toggleModal())
    }, 250)
  }

  render () {
    const { input } = this.props

    return ReactDOM.createPortal(<div className='modal'>
      <div className='head'>
        <div className='close' onClick={this.hide} />
        {appStore.dispatch(actionBuildAutocomplete(input, true))}
      </div>
    </div>,
    document.getElementById('portal')
    )
  }
}

const mapStateToProps = state => {
  return {
    ...state.modal,
    inputValue: state.board.inputValue,
    inputItems: state.board.inputItems,
    inputStartValue: state.board.inputStartValue,
    inputStartItems: state.board.inputStartItems,
    inputEndValue: state.board.inputEndValue,
    inputEndItems: state.board.inputEndItems
  }
}

export default connect(mapStateToProps)(Modal)
